const SECTION_SELECTOR = '.marquee';
const READY_KEY = 'marqueeReady';

function initSection( section ) {
	if ( section.dataset[ READY_KEY ] ) {
		return;
	}
	section.dataset[ READY_KEY ] = 'true';

	const track = document.createElement( 'div' );
	track.className = 'marquee__track';

	const items = [ ...section.children ];
	items.forEach( ( item ) => track.append( item ) );
	items.forEach( ( item ) => {
		const clone = item.cloneNode( true );
		clone.setAttribute( 'aria-hidden', 'true' );
		track.append( clone );
	} );

	section.append( track );
	section.classList.add( 'is-running' );
}

const Marquee = {
	init( root = document ) {
		root.querySelectorAll( SECTION_SELECTOR ).forEach( initSection );
	},
};

export default Marquee;
